/**
 * Audit times read in local time (the default) or UTC, the app-wide choice
 * shared with an idea's research history.
 */

import { useTimeZone } from '@/ui/useTimeZone';

/** The app-wide Local / UTC choice (`ui/useTimeZone.ts`). */
export const useAuditTimeZone = useTimeZone;

export function formatAuditTime(iso: string, utc: boolean): string {
  return new Date(iso).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: utc ? 'UTC' : undefined,
  });
}
